"use strict";

const core = require('./core');
const {ConfigurePane, ConfigurePaneCollapse, CollapsiblePane} = require('./core');

const mix = require('./mix');
exports.mix = mix;

// Do not remove, this is for side effects here.
require('./environments');
require('./filters-hash');
require('./time-range');

// TODO: These are legacy components
const CONFIGURE_PANE_HORIZONTAL_TEMPLATE = require('../../templates/configure-pane-environments.html');
class ConfigurePaneHorizontal extends mix(CollapsiblePane, 'ENVIRONMENTS', 'TIME_RANGE') {
	constructor(options) {
		super(options);
		this._template = CONFIGURE_PANE_HORIZONTAL_TEMPLATE;
		this.initTimeRange();
		this.initEnvironmentsToggles();
	}
}

const CONFIGURE_PANE_FILTERS_TEMPLATE = require('../../templates/configure-pane-filters-hash.html');
class ConfigurePaneWithFilters extends mix(CollapsiblePane, 'FILTERS', 'TIME_RANGE') {
	constructor(options) {
		super(options);
		this._template = CONFIGURE_PANE_FILTERS_TEMPLATE;
		this.initTimeRange();
		this.initFiltersHash();
	}
}
exports.ConfigurePaneWithFilters = ConfigurePaneWithFilters;

module.exports = {
	ConfigurePane, ConfigurePaneCollapse, CollapsiblePane,
	ConfigurePaneHorizontal, ConfigurePaneWithFilters,
	mix
};